import styles from './styles/Datepicker.module.scss';
import cn from 'classnames';
import dayjs, { Dayjs } from 'dayjs';
import Clickable from './Clickable';

function makeDateArray(date: Dayjs, size?: 5 | 7) {
  const dates = [
    date.clone().subtract(2, 'day'),
    date.clone().subtract(1, 'day'),
    date,
    date.clone().add(1, 'day'),
    date.clone().add(2, 'day')
  ];

  if (size == 7) {
    return [date.clone().subtract(3, 'day'), ...dates, date.clone().add(3, 'day')];
  } else {
    return dates;
  }
}

interface DatepickerProps {
  value?: Date;
  makeDatePath: (date: Date) => string;
  options?: Date[];
  onClickCalendar?: () => void;
  className?: string;
}

export default function Datepicker({ value, makeDatePath, options, onClickCalendar, className }: DatepickerProps) {
  const selectedDate = dayjs(value);
  const datesLength = 7;

  const dates = options?.map(dayjs) || makeDateArray(selectedDate, datesLength);

  return (
    <div className={cn(styles.Datepicker, className)}>
      {dates.map(date => (
        <Clickable
          key={date.toString()}
          href={makeDatePath(date.toDate())}
          className={cn(styles.Date, {
            [styles.SelectedDate]: date.isSame(selectedDate, 'day')
          })}
        >
          <div className={styles.Month}>{date.format('ddd').toUpperCase()}</div>
          <div className={styles.Day}>{date.format('MMM D').toUpperCase()}</div>
        </Clickable>
      ))}
      {onClickCalendar && (
        <>
          <div className={styles.Divider} />
          <Clickable className={styles.CalendarButton} onClick={onClickCalendar}>
            <svg width="14" height="16" viewBox="0 0 14 16">
              <path
                d="M5,1V2H9V1a1,1,0,0,1,2,0V2h1.5A1.5,1.5,0,0,1,14,3.5V5H0V3.5A1.5,1.5,0,0,1,1.5,2H3V1A1,1,0,0,1,5,1ZM0,6H14v8.5A1.5,1.5,0,0,1,12.5,16H1.5A1.5,1.5,0,0,1,0,14.5ZM2,9.5a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,4,9.5v-1A.5.5,0,0,0,3.5,8h-1a.5.5,0,0,0-.5.5Zm4,0a.5.5,0,0,0,.5.5h1A.5.5,0,0,0,8,9.5v-1A.5.5,0,0,0,7.5,8h-1a.5.5,0,0,0-.5.5ZM10.5,8a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5ZM2,13.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5ZM6.5,12a.5.5,0,0,0-.5.5v1a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5ZM10,13.5a.5.5,0,0,0,.5.5h1a.5.5,0,0,0,.5-.5v-1a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,0-.5.5Z"
                fill="#5b667c"
              />
            </svg>
          </Clickable>
        </>
      )}
    </div>
  );
}
